import { z } from 'zod';
/**
 * Tile Tap — speed + precision.
 *
 * A 4x4 board. One tile is active; clicking it advances the sequence. Clicking
 * any other tile is a miss and costs a fixed time penalty. Score contribution is
 * `elapsed + misses * TILE_MISS_PENALTY_MS`, computed server-side.
 */
export const TILE_GRID_SIZE = 4;
export const TILE_COUNT = TILE_GRID_SIZE * TILE_GRID_SIZE; // 16 cells
/* -------------------------------------------------------------------------- */
/* Client -> server events                                                     */
/* -------------------------------------------------------------------------- */
/**
 * The client sends only *which cell was clicked*. It deliberately does not send
 * a timestamp: the server stamps arrival time, so a client cannot claim it
 * clicked faster than it did.
 */
export const TileTapTapEvent = z.object({
    type: z.literal('tap'),
    /** Flat index into the 4x4 board, row-major. 0..15 */
    cell: z.number().int().min(0).max(TILE_COUNT - 1),
});
export const TileTapEvent = z.discriminatedUnion('type', [TileTapTapEvent]);
//# sourceMappingURL=tile-tap.js.map